import React from 'react';
import './PanelNavbar.css';

const PanelNavbar = ({ onClose, variant = 'default', logo = null }) => {
    const navbarClass = `panel-navbar ${variant === 'dark' ? 'panel-navbar-dark' : ''}`;

    return (
        <nav className={navbarClass}>
            <div className="panel-logo-wrapper">
                {logo && (
                    <img
                        src={logo}
                        alt="Panel Logo"
                        className="panel-logo"
                    />
                )}
            </div>
            <button className="panel-close-btn" onClick={onClose}>
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" className="close-icon">
                    <path d="M23.75 30.0834L12.6667 19.0001L23.75 7.91675" stroke={variant === 'dark' ? '#ffffff' : '#12a0c0'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </nav>
    );
};

export default PanelNavbar;
